import Link from 'next/link';

import useRoutePaths from '@/src/hooks/useRoutePaths';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Card} from '@/src/ui';

import css from '../styles/PostCard.module.css';

const PDF_PREVIEW_IMAGE = '/images/filesOnly.jpg';

type PostCardProps = {
  previewImage?: string;
  title: string;
  author: string;
  duration: string;
  id: string;
  slug: string;
  isWatchCourse: boolean;
  isPublic?: boolean;
};

const PostCard = ({
  previewImage,
  title,
  author,
  duration,
  id,
  slug,
  isWatchCourse,
  isPublic,
}: PostCardProps) => {
  const {WATCH_COURSE_ROUTE, COURSES_ROUTE} = useRoutePaths();

  return (
    <Link
      href={{
        // @ts-ignore
        pathname: isWatchCourse
          ? WATCH_COURSE_ROUTE.getLink(slug)
          : COURSES_ROUTE.getLink(slug),
        query: {postId: id},
      }}
    >
      <a className={css.postCardWrapper}>
        <Card innerOffset={Card.INNER_OFFSET.MEDIUM_EQUAL}>
          <div className={css.postCardContent}>
            <div className={css.imageWrapper}>
              <img
                className={css.image}
                src={previewImage ? previewImage : PDF_PREVIEW_IMAGE}
                alt=""
              />
              {isPublic && (
                <div className={css.freeBadge}>
                  <TextLocal id={'search.availabilityFree'} />
                </div>
              )}
              {previewImage && (
                <img
                  className={css.imagePlayIcon}
                  src="/icons/playVideoIcon.svg"
                  alt=" "
                />
              )}
            </div>

            <div>
              <div className={css.info}>
                <div className={css.author}>{author}</div>
                <div className={css.totalTime}>{duration}</div>
              </div>
              <div className={css.title}>{title}</div>
            </div>
          </div>
        </Card>
      </a>
    </Link>
  );
};

export default PostCard;
